import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import type { TaskListItem, TaskListPublication } from "./useTaskListSubscription";
import { TaskRow } from "./TaskRow";

interface TaskDataGridProps {
  items: TaskListItem[];
}

export const TASK_TYPE_LABELS: Record<TaskListItem["taskType"], string> = {
  generation_anchor_topic: "Anchor topic",
  generation_relevant_topic: "Relevant topic",
  generation_relevant_topic_fixed: "Relevant topic (Fixed)",
  homepage_publication: "Homepage publication",
  sitewide_publication: "Sitewide",
};

export const PUBLICATION_TYPE_LABELS: Record<TaskListPublication["type"], string> = {
  article: "Статья",
  homepage: "Homepage",
  sitewide: "Sitewide",
};

export function TaskDataGrid(props: TaskDataGridProps) {
  const { items } = props;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 40 }} />
            <TableCell>Тип задачи</TableCell>
            <TableCell>URL</TableCell>
            <TableCell>Язык</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell align="right">Анкоров</TableCell>
            <TableCell>Фаза</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Тип публикации</TableCell>
            <TableCell>Создана</TableCell>
            <TableCell>Автор</TableCell>
            <TableCell>Последняя публикация</TableCell>
            <TableCell>Комментарий</TableCell>
            <TableCell sx={{ width: 40 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TaskRow key={item.id} item={item} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
